export default "__VITE_ASSET__Doi2l3Hd__"